var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',{attrs:{"dis-hover":""}},[_c('Tabs',{attrs:{"value":"name1"}},[_c('TabPane',{attrs:{"label":_vm.label1,"name":"name1"}},[_c('PdReceive',{on:{"refresh-receive-count":_vm.refreshReceiveCount}})],1),_c('TabPane',{attrs:{"label":_vm.label2,"name":"name2"}},[_c('PdPushList',{on:{"refresh-push-count":_vm.refreshPushCount}})],1)],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e1edd89","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pdReferral/index.vue
// module id = null
// module chunks = 